import { SubTaxCalculation } from './sub-tax-calculation';

interface CALCULATIONS {
  title: string;
  counter: number;
}
export interface SUBCALCULATION {
  calculations: CALCULATIONS[];
}

export const SubCalculation = ({ calculations }: SUBCALCULATION) => {
  return (
    <div className="subCalculations pt-5 border-t border-blue-100">
      {calculations.map((data, index) => {
        return (
          <div
            key={index}
            className="flex justify-between gap-3 mb-6 last:mb-0"
          >
            <SubTaxCalculation title={data.title} counter={data.counter} />
          </div>
        );
      })}
    </div>
  );
};
